import axios from 'axios'

const url = window.location.href
const { origin } = new URL(url)
let react_App_SSO_DOMAIN, reactAppSSO_RedirectUrl

if (origin === process.env.REACT_APP_SSO_REDIRECT_URL_PUB) {
    react_App_SSO_DOMAIN = process.env.REACT_APP_SSO_DOMAIN_PUB
    reactAppSSO_RedirectUrl = process.env.REACT_APP_SSO_REDIRECT_URL_PUB
} else {
    react_App_SSO_DOMAIN = process.env.REACT_APP_SSO_DOMAIN
    reactAppSSO_RedirectUrl = process.env.REACT_APP_SSO_REDIRECT_URL
}

const authorize = () => {
    const url = `${react_App_SSO_DOMAIN}/openid/authorize?response_type=${
        process.env.REACT_APP_SSO_RESPONSE_TYPE
    }&client_id=${process.env.REACT_APP_CLIENT_ID}&scope=${
        process.env.REACT_APP_SSO_SCOPE
    }&redirect_uri=${encodeURIComponent(reactAppSSO_RedirectUrl)}`
    window.location.replace(url)
}

const getUser = token =>
    axios({
        url: `${react_App_SSO_DOMAIN}/openid/userinfo`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })

const getTokens = code => async () => {
    const reqData = `grant_type=${process.env.REACT_APP_GRANT_TYPE}&code=${code}&client_id=${process.env.REACT_APP_CLIENT_ID}&client_secret=${process.env.REACT_APP_CLIENT_SECRET}&redirect_uri=${reactAppSSO_RedirectUrl}`
    return axios({
        url: `${react_App_SSO_DOMAIN}/openid/token`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        data: reqData,
    })
}

const getRefreshToken = refreshToken => async () => {
    const reqData = `grant_type=refresh_token&client_id=${process.env.REACT_APP_CLIENT_ID}&refresh_token=${refreshToken}&client_secret=${process.env.REACT_APP_CLIENT_SECRET}`
    return axios({
        url: `${react_App_SSO_DOMAIN}/openid/token`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        data: reqData,
    })
}

const logout = token => {
    const reqData = `id_token_hint=${token}`
    const url = `${process.env.REACT_APP_SSO_DOMAIN}/openid/end-session-api`
    return axios({
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        data: reqData,
    })
        .then(response => {
            if (response && response.status && response.status === 200) {
                window.location.replace(process.env.REACT_APP_SSO_LOGOUT_URL)
            }
        })
        .catch(err => {
            console.error('Logout failed:', err)
        })
}

export const authClient = {
    authorize,
    getTokens,
    getRefreshToken,
    getUser,
    logout,
}
